// extracted by mini-css-extract-plugin
export default {"packages":"PackagesView_packages__J5DqQ","packageHelp":"PackagesView_packageHelp__Okuww","packageHelpText":"PackagesView_packageHelpText__gLkYQ","image":"PackagesView_image__GT8dK"};